'use client';

import { c as _c } from "react/compiler-runtime";
import { useConsent } from '@extern/consent/use-consent';
import Script from 'next/script';

/**
 * Marketing-only. Nothing here renders until the visitor has affirmatively accepted marketing:
 * the snippet loads `analytics.tiktok.com/i18n/pixel/events.js`, writes `_ttp` with
 * `firstPartyCookiesEnabled`, and fires `ttq.page()` on load — all of it visitor data leaving to a
 * third party. Gating at the render boundary rather than via `ttq.holdConsent()` keeps the request
 * itself from happening, which is the criterion; `holdConsent` would still fetch the pixel.
 *
 * Mid-session accept needs no special handling: the component re-renders, the snippet mounts, and
 * `ttq.page()` fires then, for the page the visitor is already on.
 */
export function TikTokPixelScript() {
  const $ = _c(1);
  const {
    categories
  } = useConsent();
  if (!categories.marketing) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="tiktok-script">{"\n     !function (w, d, t) {\n  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=[\"page\",\"track\",\"identify\",\"instances\",\"debug\",\"on\",\"off\",\"once\",\"ready\",\"alias\",\"group\",\"enableCookie\",\"disableCookie\",\"holdConsent\",\"revokeConsent\",\"grantConsent\"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(\nvar e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r=\"https://analytics.tiktok.com/i18n/pixel/events.js\",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement(\"script\")\n;n.type=\"text/javascript\",n.async=!0,n.src=r+\"?sdkid=\"+e+\"&lib=\"+t;e=document.getElementsByTagName(\"script\")[0];e.parentNode.insertBefore(n,e)};\n\n\n     ttq.load('D254HV3C77UB6AOK9U2G', { firstPartyCookiesEnabled: true });\n    ttq.page();\n    }(window, document, 'ttq');\n    "}</Script>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}